import { AuthService } from '@auth0/auth0-angular';
import { environment } from '@environments';

/** Logs out of Auth0 completely; clearing localStorage also ends any impersonation. */
export function logout(authService: AuthService): void {
  sessionStorage.clear();
  localStorage.clear();
  authService.logout({
    logoutParams: {
      federated: true,
      clientId: environment.auth0.clientId,
      returnTo: window.location.origin,
    },
  });
}
